/**
 * API Configuration
 */

/** When UI and API run on different localhost ports (see run-dev.ts / run-prod.ts). */
const LOCALHOST_UI_TO_API: Record<string, string> = {
  "7788": "http://localhost:7800", // run-dev.ts defaults
  "7000": "http://localhost:7001", // run-prod.ts defaults
};

// Use relative URL in production (same domain), or environment variable, or localhost for dev
const getBaseURL = () => {
  // Check if we're in browser and on production domain
  if (typeof window !== 'undefined') {
    // If we're on the production domain, use relative URLs
    if (window.location.hostname === 'testdev.orari.or.id' || 
        window.location.hostname === 'digital.orari.or.id' ||
        window.location.hostname === 'orari.or.id' ||
        window.location.hostname.includes('orari.or.id')) {
      return ''; // Relative URL - same domain
    }
  }
  
  // Use environment variable if set
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // Match bundled dev servers: UI on 7788 → API on 7800 (not 3000), else "Failed to fetch"
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    const pair = LOCALHOST_UI_TO_API[window.location.port];
    if (pair) {
      return pair;
    }
  }
  
  // Default: backend alone (e.g. bun backend/kernel.ts) on 3000
  return "http://localhost:3000";
};

export const apiConfig = {
  baseURL: getBaseURL(),
};

